// extracted by mini-css-extract-plugin
module.exports = {"jp-Notebook":"case-notebook_jp-Notebook__Ai6SF","jp-Cell":"case-notebook_jp-Cell__2NgkS"};